import { userInfoReducer } from './user';
import { headerMenuReducer } from './headerMenu';
import { stepsReducer } from './steps';
import { tinReducer } from './tinRegistration';

import { tinRegistarationStatusReducer } from './tinRegistrationStatus';
import { postRegistrationReducer } from './PostRegistration';

export const reducers = {
  user: userInfoReducer,
  headerMenu: headerMenuReducer,
  steps: stepsReducer,
  tin: tinReducer,
  postRegistration: postRegistrationReducer,
  tinStatus: tinRegistarationStatusReducer,
};
